export const parseYmlForDmg = (yml) => (
yml.split('\n').filter((line) => line.includes('dmg'))[0] || '').
split('url: ')[1] || '';

export const parseYmlForPath = (yml) => (
yml.split('\n').filter((line) => line.includes('path: '))[0] || '').
split('path: ')[1] || '';